define([
    "./monitoringIntegrationModule"
], function (module) {

    return module.provider("monitoringIntegrationUrls", [function () {
        var urls = {}

        this.setUrls = function (_urls) {
            urls = _urls;
        }

        this.$get = function () {
            return urls;
        }
    }])
})